// path: .../reducers/socialReducer.js
import { SET_FRIENDS_LIST, UPDATE_FRIEND_STATUS } from '../actions/actionTypes';

const initialState = {
  friends: [],
  onlineCount: 0,
};

export default function socialReducer(state = initialState, action) {
  switch (action.type) {
    case SET_FRIENDS_LIST:
      return {
        ...state,
        friends: action.payload,
        // Derived state: count friends who aren't offline
        onlineCount: action.payload.filter((f) => f.public_status !== 'Offline').length,
      };

    case UPDATE_FRIEND_STATUS: {
      const updatedFriends = state.friends.map((f) =>
        f.id === action.payload.friendId ? { ...f, public_status: action.payload.status } : f
      );

      return {
        ...state,
        friends: updatedFriends,
        // Recalculate count based on the new status update
        onlineCount: updatedFriends.filter((f) => f.public_status !== 'Offline').length,
      };
    }

    default:
      return state;
  }
}
